namespace TabAurous.Finance {
    export interface ServiceInwardDetailsForm {
    }

    export class ServiceInwardDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.ServiceInwardDetails';
    }
}
